import * as types from '../constants'

const initialState = {
    listComment: [],
    comment: {}
}

export default (state = initialState, action) => {
    switch (action.type) {
        case types.GET_ALL_COMMENT:
            return {
                ...state,
                listComment: action.payload
            }
        case types.REPLY_COMMENT_USER:
            return {
                ...state
            }
        case types.DELETE_COMMENT:
            var id = action.payload;
            state.listComment = state.listComment.filter(comment => {
                return comment.id !== id
            })
            return {
                ...state
            }
        default:
            return state;
    }
}